// extracted by mini-css-extract-plugin
export default {"ul":"Cart_ul__uULkx","li":"Cart_li__BJ8km","h1":"Cart_h1__6MLmN","info":"Cart_info__NT3CF"};